var HOURS_TYPE = {
  DONE: 0, // Hours the user has already spent, i.e. already been to the courses.
  PLANNED: 1, // Hours that the user plans to spend, i.e. user payed for course, but the course is not yet done.
  SHOPPING: 2, // Hours the user has put in basket, i.e. user has not purchased these courses yet.
  EMPTY: 3, // An empty slot which should be filled, but has yet to be filled.
  DONEUNSTRUCTURED: 4 // Unstructured hours the user has already spent, i.e. already done self studies.
};

module.exports = HOURS_TYPE;
